import React, { useState } from 'react';

const RegisterInterestForm: React.FC = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const handleValidation = (e: React.FormEvent) => {
        if (!validateEmail(email)) {
            e.preventDefault(); // Prevent form submission if email is invalid
            setError('Please enter a valid email address.');
        } else {
            setError('');
        }
    };

    return (
        <div className="register-interest-container">
            <h2>Register Your Interest</h2>
            <div className="register-interest-form">
                <form
                    action="https://formspree.io/f/xvgakzgy"
                    method="POST"
                    onSubmit={handleValidation}
                >
                    <input
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                    />
                    {error && <p className="error">{error}</p>}
                    <div className="button-container">
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RegisterInterestForm;